export default {
  methods: {
    // 點擊结算按鈕後，判斷是否需要發送廚房打印
    // 适用范围：[menu]
    // 备注：[order/orderDetail]页面内有同名定义函数
    autoPrint_mixin(orderId, itemsAll, itemIdsSent, callback) {
      // 如果该订单从未发送到厨房：则自动发送到厨房
      // 如果该订单以前发送任何菜品到厨房，且没有剩余未发送的：则继续，
      // 如果该订单以前发送任何菜品到厨房，且有剩余未发送的：则弹窗，询问是否需要将剩余未发送的 发送到厨房 或 删除
      if (itemsAll.length) {
        // 购物车不為空
        let flag = false
        itemsAll.forEach(x1 => {
          if (!itemIdsSent.includes(x1.id)) {
            flag = true
          }
        })
        if (flag) {
          // 购物车菜品數量!==已经發送菜品數量
          if (itemIdsSent.length) {
            // 有發送過菜品
            console.log(`%c发了${itemIdsSent.length}个，剩${itemsAll.length-itemIdsSent.length}个`, 'color: #f00;')
            this.$confirm(this.$t('print.foodNotSent'), this.$t('common.tips'), {
              confirmButtonText: this.$t('common.yes'),
              cancelButtonText: this.$t('common.no'),
              type: 'warning',
              distinguishCancelAndClose: true,
            }).then(async () => {
              // Mark 现在发送过有未发送不再发送
              callback && callback()
            })
          } else {
            // 沒有發送過菜品
            console.log(`%c一个都没发`, 'color: #f00;')
            callback && callback()
          }
        } else {
          // 已经全部發送
          callback && callback()
        }
      } else {
        // 购物车為空
        this.$message.warning(this.$t('menu.cartIsEmpty'))
      }
    },
    
    // 發送廚房打印的Ajax請求
    // 适用范围：[order|orderDetail]
    // 备注：[menu]页面内有同名定义函数
    sendAjax_sendCook_mixin(rD) {
      return this.$api.print_kitchen(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          if (Object.prototype.toString.call(_R) === '[object Array]') {
            console.log(`%c_R:`, 'color: #f00;', _R)
            this.stockErrorFoods = _R.map(x => {
              if (x.saleOut) {
                return {
                  text_zh: x.item.name_zh + ' 已售罄',
                  text_en: x.item.name_en + ' is sold out',
                }
              } else {
                return {
                  text_zh: x.item.name_zh + ' 可點數量' + x.availableCount + '份',
                  text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                }
              }
            })
            this.stockErrorFoods.push({
              text_zh: '請修改數量！',
              text_en: 'please change the quantity !',
            })
            this.$refs.DialogError.open()
            return false
          } else if (Object.prototype.toString.call(_R) === '[object Object]') {
            return _R
          }
        } else { this._status(res) }
      })
    },
  }
}